<template>
  <div class="quiz-container">
    <!-- 初始骨架屏 - 当没有questions时显示 -->
    <div class="quiz-skeleton" v-if="this.questions?.length == 0 && !isGenerating">
      <div class="skeleton-header">
        <div class="skeleton-progress">
          <div class="skeleton-progress-bar"></div>
          <div class="skeleton-progress-text"></div>
        </div>
      </div>
      <div class="skeleton-content">
        <div class="skeleton-question"></div>
        <div class="skeleton-options">
          <div class="skeleton-option" v-for="index in 4" :key="index">
            <div class="skeleton-option-icon"></div>
            <div class="skeleton-option-text"></div>
          </div>
        </div>
      </div>
      <div class="skeleton-navigation">
        <div class="skeleton-nav-button"></div>
        <div class="skeleton-nav-button"></div>
      </div>
    </div>

    <!-- 生成中的加载状态 -->
    <div class="generating-loader" v-if="isGenerating">
      <div class="loader-header">
        <div class="loader-icon">
          <i class="el-icon-loading"></i>
        </div>
        <div class="loader-title">Generating quiz questions...</div>
        <div class="loader-subtitle">AI is analyzing your note content and creating questions</div>
      </div>
      <div class="progress-bar">
        <div class="progress-fill" :style="{ width: progressWidth + '%' }"></div>
      </div>
      <div class="loader-steps">
        <div class="step" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
          <div class="step-icon">1</div>
          <div class="step-text">Analyzing content</div>
        </div>
        <div class="step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
          <div class="step-icon">2</div>
          <div class="step-text">Identifying topics</div>
        </div>
        <div class="step" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
          <div class="step-icon">3</div>
          <div class="step-text">Creating questions</div>
        </div>
        <div class="step" :class="{ active: currentStep >= 4, completed: currentStep > 4 }">
          <div class="step-icon">4</div>
          <div class="step-text">Completed</div>
        </div>
      </div>
    </div>

    <!-- 正常的quiz显示 -->
    <div class="questionbox" v-if="this.questions?.length > 0 && !isGenerating">
      <div class="quiz-header">
        <div class="quiz-progress">
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: `${(questionIndex + 1) / questions.length * 100}%` }"></div>
          </div>
          <div class="progress-text">{{ questionIndex + 1 }} / {{ questions?.length }}</div>
        </div>
        <div class="regenerate-button" @click="regenerateQuiz">
          <i class="el-icon-refresh"></i> Regenerate
        </div>
      </div>
      <div class="quiz-content">
        <p class="quiz-question">
          <span class="question-badge">Q</span>
          {{ question?.questionText }}
        </p>
        <div class="options-container">
          <div v-for="(option, index) in question?.options" :key="index" :class="[
            'option',
            {
              correct:
                question?.ischooes && question?.correctAnswerIndex == index,
              incorrect:
                question?.ischooes &&
                question?.chooese == index &&
                question?.correctAnswerIndex != question?.chooese,
              selected: question?.chooese === index
            },
          ]" @click="selectOption(index)">
            <div class="option-left">
              <span class="option-icon">{{ String.fromCharCode(65 + index) }}</span>
              <span class="option-text">{{ option }}</span>
            </div>
            <div class="option-right" v-if="question?.ischooes">
              <span class="result-icon" v-if="question?.correctAnswerIndex == index">✓</span>
              <span class="result-icon error" v-else-if="question?.chooese == index">✗</span>
            </div>
            
            <!-- 成就感元素 - 添加在每个选项中 -->
            <div class="achievement-effect" v-if="question?.ischooes && question?.correctAnswerIndex == index && index === question?.chooese">
              <div class="achievement-confetti"></div>
              <div class="achievement-stars"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-navigation">
        <button class="nav-button prev" @click.stop="prevQuestion()">
          <i class="el-icon-back"></i>
          <span>Previous</span>
        </button>
        <button class="nav-button next" @click.stop="nextQuestion()">
          <span>Next</span>
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noteobj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      questions: [],
      questionIndex: 0,
      question: {},
      showReward: false,
      timer: 10, // 倒计时初始值
      isgetnew: false, // 标记计时器是否正在运行
      isGenerating: false,
      currentStep: 1,
      progressWidth: 0,
    };
  },
  watch: {
    noteobj(val) {
      if (!val || !val.note_quiz) return;
      
      this.questions = val.note_quiz;
      if (this.questionIndex >= this.questions.length) {
        this.questionIndex = 0;
      }
      if (this.questions.length > 0) {
        this.question = this.questions[this.questionIndex];
        this.$set(this.question, "ischooes", false);
      }
    },
  },
  mounted() {
    if (!this.noteobj || !this.noteobj.note_quiz) return;

    this.questions = this.noteobj.note_quiz;

    if (this.questions.length == 0) {
      this.getnewQuestion();
    } else {
      this.question = this.questions[this.questionIndex];
      // this.$set(this.question, "ischooes", false);
    }
  },
  methods: {
    async getnewQuestion() {
      if (!this.noteobj) return;
      
      // 开始生成状态
      this.isGenerating = true;
      this.currentStep = 1;
      this.progressWidth = 10;
      
      let text = '';
      if (this.noteobj.file_type != 'record' && this.noteobj?.live_transcript?.part_objs) {
        this.noteobj.live_transcript.part_objs.forEach((part) => {
          text += part.notes || '';
        });
      } else {
        text = this.noteobj?.note_transcript || '';
      }

      if (!this.noteobj?.noteid) {
        console.error("Missing noteid in noteobj");
        this.isGenerating = false;
        return;
      }

      // 更新进度
      this.progressWidth = 25;
      this.currentStep = 2;

      const res = await this.$axios.post("api/textaction/", {
        noteid: this.noteobj.noteid,
        language: this.noteobj.language || 'en',
        action: "text2quiz",
        stream_action: "doc2quiz_stream",
        text: text,
      });
      const redata = res.data;
      if (redata.code == 200) {
        // 轮训结果
        this.progressWidth = 40;
        this.currentStep = 3;
        this.pollForFlashcards(redata.noteid, 'quiz');
      } else {
        this.isGenerating = false;
      }
    },
    async pollForFlashcards(noteid, key) {
      const INTERVAL = 2000;  // 每次轮询间隔 (毫秒)
      const MAX_TRIES = 100;   // 最大轮询次数
      
      for (let attempt = 0; attempt < MAX_TRIES; attempt++) {
        try {
          // 更新进度条
          const baseProgress = 40;
          const progressIncrement = 50 / MAX_TRIES;
          this.progressWidth = Math.min(90, baseProgress + (attempt * progressIncrement));
          
          // 查询 quiz 生成状态
          const response = await this.$axios.post("api/getnotes_bykey/", { noteid: noteid, key: key });
          if (response.data.code === 200) {
            // 生成成功，处理 quiz 数据
            this.currentStep = 4;
            this.progressWidth = 100;
            
            this.questions = response.data.note_quiz[0];
            this.$emit("setquiz", this.questions);
            if (this.questions && this.questions.length > 0) {
              for (let i = 0; i < this.questions.length; i++) {
                if (this.questions[i]) {
                  // 初始化每个问题的选择状态
                  this.$set(this.questions[i], "ischooes", false);
                  this.$set(this.questions[i], "chooese", -1);
                }
              }
              this.question = this.questions[this.questionIndex];
            }
            
            // 延迟一下再隐藏加载状态，让用户看到完成效果
            setTimeout(() => {
              this.isGenerating = false;
            }, 500);
            
            return; // 退出轮询
          }
        } catch (error) {
          console.error("Polling error: ", error);
        }
        // 如果未完成，等待一段时间再重试
        await new Promise(resolve => setTimeout(resolve, INTERVAL));
      }

      console.error("Max attempts reached. Quiz generation failed.");
      this.isGenerating = false;
    },
    selectOption(index) {
      if (!this.question || this.question?.ischooes) return;
      
      // 更新当前问题的选择状态
      this.$set(this.questions[this.questionIndex], "ischooes", true);
      this.$set(this.questions[this.questionIndex], "chooese", index);
      
      // 更新当前问题对象
      this.question = this.questions[this.questionIndex];
      
      // 如果答案正确，触发成就效果
      if (index === this.question.correctAnswerIndex) {
        this.showAchievementEffect();
      }
    },
    showAchievementEffect() {
      // 创建彩色纸屑和星星效果
      this.$nextTick(() => {
        this.createAchievementEffects();
      });
    },
    createAchievementEffects() {
      // 创建纸屑效果
      const confettiContainer = document.querySelector('.achievement-confetti');
      if (confettiContainer) {
        confettiContainer.innerHTML = '';
        
        // 创建40个彩色纸屑
        for (let i = 0; i < 40; i++) {
          const confetti = document.createElement('div');
          confetti.className = 'confetti-piece';
          
          // 随机颜色
          const colors = [
            '#3498db', '#2ecc71', '#e74c3c', '#f1c40f', 
            '#9b59b6', '#1abc9c', '#2980b9'
          ];
          const color = colors[Math.floor(Math.random() * colors.length)];
          confetti.style.backgroundColor = color;
          
          // 随机大小
          const size = Math.random() * 8 + 4;
          confetti.style.width = `${size}px`;
          confetti.style.height = `${size}px`;
          
          // 随机起始位置
          confetti.style.left = `${Math.random() * 120 - 10}%`;
          
          // 随机动画延迟
          confetti.style.animationDelay = `${Math.random() * 0.5}s`;
          
          // 随机动画时长
          confetti.style.animationDuration = `${Math.random() * 2 + 1}s`;
          
          // 随机旋转
          confetti.style.transform = `rotate(${Math.random() * 360}deg)`;
          
          // 随机形状
          const shapeType = Math.floor(Math.random() * 4);
          
          if (shapeType === 0) {
            // 圆形
            confetti.style.borderRadius = '50%';
          } else if (shapeType === 1) {
            // 菱形
            confetti.style.clipPath = 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)';
          } else if (shapeType === 2) {
            // 三角形
            confetti.style.clipPath = 'polygon(50% 0%, 100% 100%, 0% 100%)';
          } else {
            // 长条
            confetti.style.width = `${Math.random() * 4 + 2}px`;
            confetti.style.height = `${Math.random() * 12 + 6}px`;
            confetti.style.borderRadius = '2px';
          }
          
          confettiContainer.appendChild(confetti);
        }
      }
      
      // 创建星星效果
      const starsContainer = document.querySelector('.achievement-stars');
      if (starsContainer) {
        starsContainer.innerHTML = '';
        
        // 创建10个星星
        for (let i = 0; i < 10; i++) {
          const star = document.createElement('div');
          star.className = 'star-piece';
          
          // 随机大小
          const size = Math.random() * 15 + 10;
          star.style.width = `${size}px`;
          star.style.height = `${size}px`;
          
          // 随机位置
          star.style.left = `${Math.random() * 100}%`;
          star.style.top = `${Math.random() * 100}%`;
          
          // 随机延迟
          star.style.animationDelay = `${Math.random() * 0.5}s`;
          
          // 创建星形
          star.innerHTML = '★';
          
          // 随机颜色
          const colors = ['#f1c40f', '#e67e22', '#f39c12'];
          star.style.color = colors[Math.floor(Math.random() * colors.length)];
          
          starsContainer.appendChild(star);
        }
      }
    },
    prevQuestion() {
      if (!this.questions || this.questions.length === 0) return;
      
      this.questionIndex--;
      if (this.questionIndex < 0) {
        this.questionIndex = this.questions.length - 1;
      }
      
      // 直接引用保存的问题状态
      this.question = this.questions[this.questionIndex];
    },
    nextQuestion() {
      if (!this.questions || this.questions.length === 0) return;
      
      this.questionIndex++;
      if (this.questionIndex >= this.questions.length) {
        this.questionIndex = 0;
      }
      
      // 直接引用保存的问题状态
      this.question = this.questions[this.questionIndex];
    },
    async regenerateQuiz() {
      this.questions = [];
      this.questionIndex = 0;
      this.question = {};
      this.isGenerating = true;
      this.currentStep = 1;
      this.progressWidth = 0;
      this.getnewQuestion();
    },
  },
};
</script>

<style lang="less">
.quiz-container {
  color: #2c3e50;
  padding: 1vw;
  font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  position: relative;
  overflow: hidden;
  max-width: 900px;
  margin: 0 auto;
}

.quiz-skeleton {
  padding: 20px 0;

  .skeleton-header {
    margin-bottom: 16px;

    .skeleton-progress {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 15px;

      .skeleton-progress-bar {
        height: 6px;
        flex: 1;
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        animation: pulse 1.8s infinite;
      }

      .skeleton-progress-text {
        width: 40px;
        height: 16px;
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        animation: pulse 1.8s infinite;
      }
    }
  }

  .skeleton-content {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.04);
    margin-bottom: 20px;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 16px;
      background: linear-gradient(135deg, rgba(52, 152, 219, 0.02), rgba(0, 0, 0, 0));
      z-index: 0;
    }

    .skeleton-question {
      height: 80px;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.04);
      border-radius: 12px;
      margin-bottom: 30px;
      animation: pulse 1.8s infinite;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 34px;
        height: 34px;
        background-color: rgba(52, 152, 219, 0.1);
        border-radius: 50%;
        animation: pulse 1.8s infinite;
      }
    }

    .skeleton-options {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .skeleton-option {
        display: flex;
        align-items: center;
        height: 65px;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.03);
        border-radius: 12px;
        padding: 14px 20px;
        animation: pulse 1.8s infinite;
        animation-delay: 0.1s;
        
        &:nth-child(2) {
          animation-delay: 0.2s;
          width: 97%;
        }
        
        &:nth-child(3) {
          animation-delay: 0.3s;
          width: 98%;
        }
        
        &:nth-child(4) {
          animation-delay: 0.4s;
          width: 96%;
        }

        .skeleton-option-icon {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-color: rgba(52, 152, 219, 0.08);
          margin-right: 12px;
        }

        .skeleton-option-text {
          height: 20px;
          flex: 1;
          background-color: rgba(0, 0, 0, 0.05);
          border-radius: 4px;
        }
      }
    }
  }

  .skeleton-navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .skeleton-nav-button {
      width: 120px;
      height: 45px;
      background-color: rgba(0, 0, 0, 0.04);
      border-radius: 10px;
      animation: pulse 1.8s infinite;

      &:first-child {
        animation-delay: 0.2s;
      }
      
      &:last-child {
        background: rgba(52, 152, 219, 0.08);
        animation-delay: 0.3s;
      }
    }
  }
}

.questionbox {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

.quiz-header {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .quiz-progress {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    margin: 8px 0;

    .progress-bar {
      height: 6px;
      background-color: rgba(0, 0, 0, 0.06);
      border-radius: 3px;
      overflow: hidden;
      width: calc(50vw - 260px - 100px - 30px);
        min-width: 190px;
      .progress-fill {
        height: 100%;
        background: linear-gradient(90deg, #3498db, #2980b9);
        border-radius: 3px;
        transition: width 0.5s ease;
      }
    }

    .progress-text {
      font-size: 14px;
      color: #5e6d82;
      white-space: nowrap;
      font-weight: 500;
    }
  }
  
  .regenerate-button {
    background-color: #3498db;
    color: white;
    padding: 6px 14px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(52, 152, 219, 0.2);
    
    &:hover {
      background-color: #2980b9;
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
    }
    
    i {
      font-size: 16px;
    }
  }
}

.quiz-content {
  background: #ffffff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  
  &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(52, 152, 219, 0.03), rgba(0, 0, 0, 0));
    z-index: -1;
  }
}

.quiz-question {
  font-size: 1.25rem;
  line-height: 1.6;
  margin-bottom: 32px;
  font-weight: 500;
  color: #2c3e50;
  position: relative;
  padding-left: 48px;
  
  &::after {
    content: '';
    position: absolute;
    left: 48px;
    bottom: -16px;
    width: 60px;
    height: 2px;
    background: rgba(52, 152, 219, 0.15);
    border-radius: 1px;
  }

  .question-badge {
    position: absolute;
    left: 0;
    top: 0;
    width: 34px;
    height: 34px;
    background: linear-gradient(135deg, #3498db, #2980b9);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(52, 152, 219, 0.25);
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.05) rotate(5deg);
      box-shadow: 0 6px 16px rgba(52, 152, 219, 0.3);
    }
  }
}

.options-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option {
  border-radius: 12px;
  background: #f8f9fa;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.04);
  margin-bottom: 2px;
  position: relative;
  
  &:not(:last-child) {
    margin-bottom: 8px;
  }

  .option-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
  }

  .option-text {
    font-size: 1rem;
    line-height: 1.4;
    color: #34495e;
    font-weight: 400;
  }

  &:hover {
    background: #f1f5f9;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.04);
  }

  &.selected:not(.correct):not(.incorrect) {
    border-color: rgba(52, 152, 219, 0.4);
    background: rgba(52, 152, 219, 0.05);
    box-shadow: 0 4px 12px rgba(52, 152, 219, 0.08);
  }

  &.correct {
    background: rgba(46, 204, 113, 0.08);
    border-color: rgba(46, 204, 113, 0.25);
    box-shadow: 0 4px 16px rgba(46, 204, 113, 0.1);
    
    &::after {
      content: '';
      position: absolute;
      top: -3px;
      left: -3px;
      right: -3px;
      bottom: -3px;
      border-radius: 14px;
      background: transparent;
      border: 2px solid rgba(46, 204, 113, 0.4);
      opacity: 0;
      z-index: 1;
      animation: correct-pulse 1.5s ease-out;
    }
  }

  &.incorrect {
    background: rgba(231, 76, 60, 0.08);
    border-color: rgba(231, 76, 60, 0.25);
    box-shadow: 0 4px 16px rgba(231, 76, 60, 0.1);
  }
}

.option-icon {
  width: 34px;
  height: 34px;
  font-size: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background: rgba(52, 152, 219, 0.1);
  color: #3498db;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.15);
}

.result-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background: rgba(46, 204, 113, 0.1);
  color: #2ecc71;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(46, 204, 113, 0.15);

  &.error {
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
    box-shadow: 0 2px 8px rgba(231, 76, 60, 0.15);
  }
}

.card-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
  .nav-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 25px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.1), transparent);
      transform: translateX(-100%);
      transition: transform 0.6s ease;
    }
    
    &:hover::before {
      transform: translateX(100%);
    }

    &.prev {
      background: #f8f9fa;
      color: #34495e;
      border: 1px solid rgba(0, 0, 0, 0.04);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

      &:hover {
        background: #edf2f7;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      }
      
      i {
        margin-right: 2px;
        opacity: 0.8;
        transition: all 0.3s ease;
      }
      
      &:hover i {
        transform: translateX(-3px);
        opacity: 1;
      }
    }

    &.next {
      background: linear-gradient(90deg, #3498db, #2980b9);
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(52, 152, 219, 0.15);

      &:hover {
        background: linear-gradient(90deg, #2b8cc9, #2472a4);
        box-shadow: 0 6px 16px rgba(52, 152, 219, 0.25);
        transform: translateY(-2px);
      }
      
      i {
        margin-left: 2px;
        opacity: 0.8;
        transition: all 0.3s ease;
      }
      
      &:hover i {
        transform: translateX(3px);
        opacity: 1;
      }
    }

    i {
      font-size: 16px;
    }
  }
}

@keyframes confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg) scale(1);
    opacity: 1;
  }
  50% {
    opacity: 0.8;
    transform: translateY(50vh) rotate(180deg) scale(0.8);
  }
  100% {
    transform: translateY(100vh) rotate(360deg) scale(0.6);
    opacity: 0;
  }
}

@keyframes pulse {
  0% {
    opacity: 0.5;
  }

  50% {
    opacity: 0.2;
  }

  100% {
    opacity: 0.5;
  }
}

@media (max-width: 768px) {
  .quiz-container {
    padding: 15px;
  }

  .generating-loader {
    padding: 40px 15px;

    .loader-header {
      margin-bottom: 30px;

      .loader-icon {
        font-size: 40px;
        margin-bottom: 12px;

        i {
          font-size: 40px;
        }
      }

      .loader-title {
        font-size: 20px;
      }

      .loader-subtitle {
        font-size: 14px;
      }
    }

    .progress-bar {
      margin-bottom: 30px;
    }

    .loader-steps {
      .step {
        .step-icon {
          width: 28px;
          height: 28px;
          font-size: 12px;
        }

        .step-text {
          font-size: 11px;
        }
      }
    }
  }

  .quiz-content {
    padding: 24px 20px;
  }

  .quiz-question {
    font-size: 1.1rem;
    padding-left: 42px;
    margin-bottom: 28px;
    
    &::after {
      left: 42px;
      width: 50px;
    }
  }

  .option {
    padding: 15px 20px;

    .option-text {
      font-size: 1rem;
    }
  }
  
  .card-navigation {
    margin-top: 20px;
    
    .nav-button {
      padding: 10px 20px;
      font-size: 14px;
    }
  }
}

@media (max-width: 480px) {
  .quiz-container {
    padding: 10px;
  }

  .generating-loader {
    padding: 30px 10px;

    .loader-header {
      margin-bottom: 25px;

      .loader-icon {
        font-size: 36px;
        margin-bottom: 10px;

        i {
          font-size: 36px;
        }
      }

      .loader-title {
        font-size: 18px;
      }

      .loader-subtitle {
        font-size: 13px;
      }
    }

    .progress-bar {
      margin-bottom: 25px;
      height: 5px;
    }

    .loader-steps {
      flex-wrap: wrap;
      gap: 15px;

      .step {
        flex: 0 0 calc(50% - 7.5px);
        margin-bottom: 10px;

        &:not(:last-child)::after {
          display: none;
        }

        .step-icon {
          width: 24px;
          height: 24px;
          font-size: 11px;
        }

        .step-text {
          font-size: 10px;
        }
      }
    }
  }
  
  .quiz-content {
    padding: 16px;
  }
  
  .quiz-question {
    font-size: 1rem;
    padding-left: 38px;
    
    .question-badge {
      width: 30px;
      height: 30px;
      font-size: 14px;
    }
  }
  
  .option {
    padding: 12px 16px;
    
    .option-left {
      gap: 10px;
    }
    
    .option-icon {
      width: 32px;
      height: 32px;
      font-size: 14px;
    }
    
    .option-text {
      font-size: 0.95rem;
    }
  }
  
  .card-navigation {
    margin-top: 16px;
    
    .nav-button {
      padding: 10px 16px;
      font-size: 13px;
      
      i {
        font-size: 14px;
      }
    }
  }
}

/* 新的成就效果样式 */
.achievement-effect {
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  pointer-events: none;
  overflow: hidden;
  border-radius: 12px;
  z-index: 5;
}

.achievement-confetti {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.confetti-piece {
  position: absolute;
  top: -10px;
  width: 6px;
  height: 6px;
  background: #3498db;
  opacity: 0.8;
  border-radius: 2px;
  animation: achievement-confetti-fall 1.5s ease-out forwards;
}

.achievement-stars {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.star-piece {
  position: absolute;
  font-size: 16px;
  color: #f1c40f;
  animation: star-pulse 1s ease-in-out infinite, star-fade 1.5s ease-out forwards;
  opacity: 0;
}

/* 新动画 */
@keyframes achievement-confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.8;
  }
  100% {
    transform: translateY(100px) rotate(360deg);
    opacity: 0;
  }
}

@keyframes star-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
}

@keyframes star-fade {
  0% {
    opacity: 0;
    transform: scale(0.5) rotate(0deg);
  }
  20% {
    opacity: 1;
    transform: scale(1.2) rotate(20deg);
  }
  80% {
    opacity: 1;
    transform: scale(1) rotate(-10deg);
  }
  100% {
    opacity: 0;
    transform: scale(1.5) rotate(0deg);
  }
}

@keyframes popup-rise {
  0% {
    top: 20px;
    opacity: 0;
  }
  20% {
    top: -45px;
    opacity: 1;
  }
  80% {
    top: -50px;
    opacity: 1;
  }
  100% {
    top: -60px;
    opacity: 0;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}

@keyframes correct-pulse {
  0% {
    transform: scale(0.95);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.3;
  }
  100% {
    transform: scale(1.1);
    opacity: 0;
  }
}

/* 生成中加载状态样式 */
.generating-loader {
  margin-top: 20px;
  padding: 60px 20px;
  text-align: center;
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.03) 0%, rgba(155, 89, 182, 0.03) 100%);
  border-radius: 16px;
  border: 1px solid rgba(52, 152, 219, 0.08);
  margin-bottom: 28px;

  .loader-header {
    margin-bottom: 40px;

    .loader-icon {
      font-size: 48px;
      color: #3498db;
      margin-bottom: 16px;
      animation: spin 2s linear infinite;

      i {
        font-size: 48px;
      }
    }

    .loader-title {
      font-size: 24px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 8px;
    }

    .loader-subtitle {
      font-size: 16px;
      color: #5e6d82;
      line-height: 1.5;
    }
  }

  .progress-bar {
    width: 100%;
    height: 6px;
    background-color: rgba(52, 152, 219, 0.1);
    border-radius: 3px;
    margin-bottom: 40px;
    overflow: hidden;

    .progress-fill {
      height: 100%;
      background: linear-gradient(90deg, #3498db 0%, #9b59b6 100%);
      border-radius: 3px;
      transition: width 0.3s ease;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-image: linear-gradient(-45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent);
        background-size: 30px 30px;
        animation: progressStripe 1s linear infinite;
      }
    }
  }

  .loader-steps {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 600px;
    margin: 0 auto;

    .step {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      opacity: 0.4;
      transition: all 0.3s ease;

      &.active {
        opacity: 1;
        
        .step-icon {
          background-color: #3498db;
          color: white;
          transform: scale(1.1);
        }
      }

      &.completed {
        opacity: 1;
        
        .step-icon {
          background-color: #27ae60;
          color: white;

          &::after {
            content: '✓';
            font-size: 12px;
          }
        }
      }

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: 16px;
        left: 60%;
        width: 80%;
        height: 2px;
        background-color: rgba(52, 152, 219, 0.2);
        z-index: 0;
      }

      .step-icon {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: rgba(52, 152, 219, 0.1);
        color: #5e6d82;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
        transition: all 0.3s ease;
        z-index: 1;
        position: relative;
      }

      .step-text {
        font-size: 12px;
        color: #5e6d82;
        text-align: center;
        line-height: 1.3;
      }
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes progressStripe {
  from {
    background-position: 30px 0;
  }

  to {
    background-position: 0 0;
  }
}
</style>

